import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Intro from "../components/partials/homepage/intro"
import About from "../components/partials/homepage/about"
import Work from "../components/partials/homepage/work"
import BlogList from "../components/partials/blog-list-h3"

const PortfolioIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <Intro />
      <About />
      <Work
        work={data.work.edges}
      />
      <section className="margin-top-64">
        <div className="container container--small">
          <h2 className="text-align-center">
            <Link to="/blog">
              Blog
            </Link>
          </h2>
          <hr/>
          <BlogList
            blogs={data.blogs.edges}
          />
        </div>
      </section>
    </Layout>
  )
}

export default PortfolioIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    work: allMarkdownRemark(
      filter: {
        fields: { collection: { eq: "work" } }
      }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            image_url {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  width: 550
                  placeholder: BLURRED
                )
              }
            }
            image_alt
            link_1_copy
            link_1_link
            link_2_copy
            link_2_link
            link_document_copy
            link_document_link {
              publicURL
            }
            description
          }
        }
      }
    }
    blogs: allMarkdownRemark(
      filter: {
        fields: { 
          collection: { eq: "blog" }
        }
        frontmatter: { 
          draft: { ne: true } 
        }
      }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`;

export const Head = () => {
  return <Seo title="Portfolio" />;
};